import { render } from "./shoppingCart .vue?vue&type=template&id=754a4b44&scoped=true"
import script from "./shoppingCart .vue?vue&type=script&lang=js"
export * from "./shoppingCart .vue?vue&type=script&lang=js"

import "./shoppingCart .vue?vue&type=style&index=0&id=754a4b44&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754a4b44"]])

export default __exports__